var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.accountState !== _vm.ACCOUNT_STATES.nil
    ? _c(
        "div",
        {
          staticClass: "state-banner",
          class: "state-banner--" + _vm.accountState
        },
        [
          _c("div", { staticClass: "state-banner__inner" }, [
            _vm.accountState === _vm.ACCOUNT_STATES.approved
              ? _c(
                  "p",
                  { staticClass: "state-banner__message" },
                  [
                    _c("md-icon", { staticClass: "md-icon-size-065x" }, [
                      _vm._v("verified_user")
                    ]),
                    _vm._v(
                      "\n      " +
                        _vm._s(_vm.i18n.kyc_approved_msg()) +
                        "\n    "
                    )
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.accountState === _vm.ACCOUNT_STATES.pending
              ? _c(
                  "p",
                  { staticClass: "state-banner__message" },
                  [
                    _c("md-icon", { staticClass: "md-icon-size-065x" }, [
                      _vm._v("watch_later")
                    ]),
                    _vm._v(
                      "\n      " + _vm._s(_vm.i18n.kyc_waiting_msg()) + "\n    "
                    )
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.accountState === _vm.ACCOUNT_STATES.rejected
              ? _c(
                  "p",
                  { staticClass: "state-banner__message" },
                  [
                    _c("md-icon", { staticClass: "md-icon-size-065x" }, [
                      _vm._v("warning")
                    ]),
                    _vm._v(
                      "\n      " +
                        _vm._s(_vm.i18n.kyc_rejected_msg()) +
                        "\n    "
                    )
                  ],
                  1
                )
              : _vm._e()
          ])
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-9e514672", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9e514672","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/vue/app/verification/make/Verification.StateBanner.vue
// module id = gSvV
// module chunks = 1